import * as commonScripts from '../common'
import { TimelineLite } from 'gsap/all'
import 'whatwg-fetch'

const cmpNewsList = {
  component: null,
  resultsDiv: null,
  nextBtn: null,
  prevBtn: null,
  animation: 'right',
	listPageId: null,
  language: null,
  apiEndpoint: null,
  storedPageKey: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    _.nextBtn = element.querySelector('[data-dir="next"]')
    _.prevBtn = element.querySelector('[data-dir="prev"]')
    _.resultsDiv = element.querySelector('.cmp-news-list__content')
		_.listPageId = element.querySelector('#list-page-id').value
    _.apiEndpoint = element.getAttribute('data-api-endpoint')
    _.storedPageKey = element.getAttribute('data-stored-page') 
    _.language = document.documentElement.lang
    if (_.language.length === 0) {
      _.language = 'en'
    }

		var strStoredPage = window.localStorage.getItem(_.storedPageKey)
		var storedPage = 1;
		if (strStoredPage != "") {
			storedPage = parseInt(strStoredPage, 10);
		}

		var pageSize = parseInt(element.querySelector('#page-size').value, 10);

		_.buildQuery(_.listPageId, storedPage, pageSize);

		element.querySelectorAll('.nav').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()

				var p = element.querySelector("#current-page");
				var qpage = parseInt(p.value, 10);

				_.nextBtn.setAttribute('disabled', '')
				_.prevBtn.setAttribute('disabled', '')

				if (el.getAttribute('data-dir') === 'prev') {
					_.animation = 'left'
					qpage = (qpage < 2) ? 1 : qpage - 1;
				} else {
					_.animation = 'right';
					qpage++;
				}

				_.buildQuery(_.listPageId, qpage, pageSize)
			})
		});

		var wrapper = document.querySelector(".cmp-news-list__content")
		wrapper.addEventListener("click", e => {
			var currentPage = document.getElementById("current-page");
			window.localStorage.setItem(_.storedPageKey, currentPage.value);
			return true;
		});
  },

  buildQuery: function (id,pageNumber,pageSize) {
		const _ = this
		let query = '?p=' + pageNumber + '&s=' + pageSize +'&lang=' + _.language
    _.fetchResults(id,query)
  },

  fetchResults: function (lastSegement,query) {
    const _ = this
    const fetchOpts = {
      method: 'GET',
      headers: {}
    }

		window.fetch(_.apiEndpoint + lastSegement + query, fetchOpts)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.text()
      }).then((body) => {
        _.processResponse(body)
      }).catch((err) => {
        console.log('Request Failed', err)
      })
  },

  processResponse: function (body) {
    const _ = this
    const cards = _.resultsDiv.querySelector('.row')
    const stagingDiv = document.createElement('div')
    stagingDiv.classList.add('row', 'staging-zone')
    stagingDiv.insertAdjacentHTML('beforeend', body)
		commonScripts.util.inheritPermalink(stagingDiv)

    const tl = new TimelineLite()
    const offset = (_.animation === 'right') ? -500 : 500
    tl.to(cards, { x: offset, opacity: 0, duration: 0.5 })
    tl.eventCallback('onComplete', () => {
      _.resultsDiv.innerHTML = ''
      _.resultsDiv.appendChild(stagingDiv)
			_.showCards(stagingDiv, offset)

			var pageCount, page = 1;
			let hidPageCount = document.getElementById("page-count"),
				hidCurrentPage = document.getElementById("current-page");

			pageCount = parseInt(hidPageCount.value, 10);
			page = parseInt(hidCurrentPage.value, 10);

      _.showHideNav(page, pageCount)
    })
  },

  showCards: function (cards, offset) {
    offset = offset * -1
    if (cards) {
      const tl = new TimelineLite()
      tl.fromTo(cards, { x: offset, opacity: 0 }, { x: 0, opacity: 1, duration: 0.5 })
    }
  },

  showHideNav: function (page, pageCount) {
    const _ = this

    if (_.resultsDiv.querySelector('.no-results') || page == pageCount) {
      _.nextBtn.setAttribute('disabled', '')
    } else {
      _.nextBtn.removeAttribute('disabled')
    }

    if (page <= 1) {
      _.prevBtn.setAttribute('disabled', '')
    } else {
      _.prevBtn.removeAttribute('disabled')
    }
  }
}

export default cmpNewsList
